import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import BriefingEvent from "../event/BriefingEvent";

export default class BriefingScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this._target.headerTextField.text = this._languagePack.getText('chapters.chapter1.briefing.title');
        this._target.contentTextField.text = this._languagePack.getText('chapters.chapter1.briefing.body');

        this.createButton(this._target.continueButton, this._handleContinueButton.bind(this), "[Continue]");
    }

    destroy() {
        super.destroy();
    }

    _handleContinueButton() {
        this.disableInteraction();

        this.dispatch(BriefingEvent.CLOSE_REQUEST);
    }
}